let loadingOverlay = null;
let loadingStylesInjected = false;

function injectLoadingStyles() {
  if (loadingStylesInjected) return;

  const style = document.createElement('style');
  style.textContent = `
    .pecas-reposicao-loading {
      position: absolute;
      inset: 0;
      z-index: 20;
      display: none;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.78);
      backdrop-filter: blur(2px);
      border-radius: 0.75rem;
      pointer-events: all;
    }

    .pecas-reposicao-loading__spinner {
      width: 2.5rem;
      height: 2.5rem;
      border: 0.25rem solid rgba(17, 24, 39, 0.15);
      border-top-color: #111827;
      border-radius: 999px;
      animation: pecas-reposicao-spin 0.8s linear infinite;
    }

    @keyframes pecas-reposicao-spin {
      to {
        transform: rotate(360deg);
      }
    }
  `;

  document.head.appendChild(style);
  loadingStylesInjected = true;
}

function ensureLoadingOverlay() {
  injectLoadingStyles();

  if (loadingOverlay) return loadingOverlay;

  const mountTarget = document.querySelector('.product-grid-container, .collection-wrapper');
  loadingOverlay = document.createElement('div');
  loadingOverlay.className = 'pecas-reposicao-loading';
  loadingOverlay.setAttribute('aria-live', 'polite');
  loadingOverlay.setAttribute('aria-label', 'Carregando produtos');
  loadingOverlay.innerHTML = '<div class="pecas-reposicao-loading__spinner" aria-hidden="true"></div>';

  if (mountTarget) {
    const currentPosition = window.getComputedStyle(mountTarget).position;
    if (currentPosition === 'static') {
      mountTarget.style.position = 'relative';
    }

    mountTarget.appendChild(loadingOverlay);
  } else {
    document.body.appendChild(loadingOverlay);
  }

  return loadingOverlay;
}

function showLoadingOverlay() {
  const overlay = ensureLoadingOverlay();
  const grid = document.querySelector('.product-grid-accessories');
  overlay.style.display = 'flex';
  if (grid) {
    grid.classList.remove('has-accessories-filter');
  }
}

function hideLoadingOverlay() {
  if (loadingOverlay) {
    loadingOverlay.style.display = 'none';
  }
}

class PecasReposicaoFilter {
  constructor() {
    this.searchInput = document.querySelector('.search-input');
    this.filterButtons = document.querySelectorAll('[data-filter-category]');
    this.catalogItems = document.querySelectorAll('.catalog-item');
    this.selectedCategories = new Set();

    this.init();
    this.initAccessoryFilter();
  }

  init() {
    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => this.filterItems());
    }

    this.filterButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const category = button.getAttribute('data-filter-category');
        
        if (this.selectedCategories.has(category)) {
          this.selectedCategories.delete(category);
          button.classList.remove('active');
        } else {
          this.selectedCategories.add(category);
          button.classList.add('active');
        }
        
        this.filterItems();
      });
    });
  }

  initAccessoryFilter() {
    const url = new URL(window.location.href);
    const accessoriesParam = url.searchParams.get('accessories') || '';
    const categoryParam = url.searchParams.get('category') || '';

    if (!accessoriesParam) return;

    const accessoryHandles = accessoriesParam.split(',').map((h) => h.trim());
    const cards = document.querySelectorAll('[data-product-handle]');

    console.log('Filtering by accessories:', accessoryHandles);
    if (categoryParam) {
      console.log('Also filtering by category:', categoryParam);
    }

    cards.forEach((card) => {
      const cardHandle = card.dataset.productHandle || '';
      const cardTags = (card.dataset.productTags || '').split(' ');

      const matchesAccessories = accessoryHandles.includes(cardHandle);
      const matchesCategory = !categoryParam || cardTags.includes(categoryParam);

      card.style.display = matchesAccessories && matchesCategory ? '' : 'none';
    });
  }

  filterItems() {
    const searchTerm = this.searchInput?.value.toLowerCase() || '';
    const hasFilters = this.selectedCategories.size > 0;

    this.catalogItems.forEach((item) => {
      const titleElement = item.querySelector('.catalog-item-title');
      const title = titleElement?.textContent.trim().toLowerCase() || '';
      
      // Filtro de pesquisa
      const matchesSearch = title.includes(searchTerm);

      // Filtro de categorias
      let matchesCategory = true;
      if (hasFilters) {
        const dataItem = item.getAttribute('data-item');
        try {
          const itemData = JSON.parse(dataItem);
          const itemFilters = itemData.filtros || [];
          matchesCategory = Array.from(this.selectedCategories).some(
            (selected) => itemFilters.includes(selected)
          );
        } catch (e) {
          matchesCategory = false;
        }
      }

      // Mostrar item se passar em ambos os filtros
      if (matchesSearch && matchesCategory) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }
}

async function resolveSearchLinks() {
  const links = document.querySelectorAll('.catalog-item-link[data-search-term]');
  if (!links.length) return;

  await Promise.all(
    Array.from(links).map(async (link) => {
      const anchor = /** @type {HTMLAnchorElement} */ (link);
      const term = anchor.dataset.searchTerm;
      if (!term) return;
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=2`;
        const res = await fetch(url);
        const data = await res.json();
        const products = data?.resources?.results?.products ?? [];

        if (products.length <= 1) {
          const item = /** @type {HTMLElement} */ (anchor.closest('.catalog-item'));
          if (item) item.style.display = 'none';
        }
      } catch {
        // Keep item visible on error
      }
    })
  );
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PecasReposicaoFilter();
    resolveSearchLinks();
    filterAccessoriesByProduct();
  });
} else {
  new PecasReposicaoFilter();
  resolveSearchLinks();
  filterAccessoriesByProduct();
}

/**
 * On the accessories collection page, reads the ?product= URL param and hides
 * any product card whose data-compatible attribute does not include that handle.
 */
function filterAccessoriesByProduct() {
  const params = new URLSearchParams(window.location.search);
  const accessoriesParam = params.get('accessories');
  if (!accessoriesParam) {
    hideLoadingOverlay();
    document.documentElement.classList.remove('has-accessories-filter');
    return;
  }
  showLoadingOverlay();

  const allowedHandles = accessoriesParam
    .split(',')
    .map((handle) => handle.trim())
    .filter(Boolean);

  if (!allowedHandles.length) {
    hideLoadingOverlay();
    return;
  }

  const selector = '.product-grid__item[data-product-handle], .product-grid__item[data-product-handle] *';

  function processCards() {
    const cards = document.querySelectorAll('.product-grid__item[data-product-handle]');
    if (!cards.length) {
      hideLoadingOverlay();
      return;
    }

    cards.forEach((card) => {
      const handle = card.getAttribute('data-product-handle');
      if (!handle || !allowedHandles.includes(handle)) {
        card.style.display = 'none';
      } else {
        card.style.display = '';
      }
    });

    hideLoadingOverlay();
  }

  // If cards already present, process immediately
  if (document.querySelectorAll('.product-grid__item[data-product-handle]').length) {
    // small timeout to allow any rendering/layout to settle
    setTimeout(processCards, 40);
    return;
  }

  // Otherwise observe the container for when items are added
  const mountTarget = document.querySelector('.product-grid-container, .collection-wrapper');
  if (!mountTarget) {
    // fallback: poll briefly
    const poll = setInterval(() => {
      if (document.querySelectorAll('.product-grid__item[data-product-handle]').length) {
        clearInterval(poll);
        processCards();
      }
    }, 100);
    setTimeout(() => clearInterval(poll), 3000);
    return;
  }

  const observer = new MutationObserver((mutations, obs) => {
    if (document.querySelectorAll('.product-grid__item[data-product-handle]').length) {
      obs.disconnect();
      processCards();
    }
  });

  observer.observe(mountTarget, { childList: true, subtree: true });
}

